import React, { useContext, useMemo } from 'react';
import BoardsContext from '../../../../contexts/BoardsContext';
import isCustomerLaneBoard from '../../../../isCustomerLaneBoard';

const usePermittedCustomerLaneCommitmentBoards = () => {
  const { boards } = useContext(BoardsContext);

  const laneBoards = useMemo((): CustomerLaneBoard[] => {
    return boards.filter(isCustomerLaneBoard).filter((b) => !b.isHidden);
  }, [boards]);

  return laneBoards;
};

const useCustomerLaneCommitmentBoards = ({
  selectedCustomerLaneCommitmentsBoard,
  setSelectedCustomerLaneCommitmentsBoard,
  setTitle,
}: {
  selectedCustomerLaneCommitmentsBoard: CustomerLaneBoard | undefined;
  setSelectedCustomerLaneCommitmentsBoard: React.Dispatch<
    React.SetStateAction<CustomerLaneBoard | undefined>
  >;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const laneBoards = usePermittedCustomerLaneCommitmentBoards();

  const options = useMemo((): DropdownOption[] => {
    return laneBoards.map((d) => ({
      key: d.id,
      label: d.name,
      isSelected:
        !!selectedCustomerLaneCommitmentsBoard &&
        d.id === selectedCustomerLaneCommitmentsBoard.id,
      onSelected: () => {
        setSelectedCustomerLaneCommitmentsBoard(d);
        setTitle(d.name);
      },
    }));
  }, [
    laneBoards,
    selectedCustomerLaneCommitmentsBoard,
    setSelectedCustomerLaneCommitmentsBoard,
    setTitle,
  ]);

  return options;
};

export default useCustomerLaneCommitmentBoards;
